import config from 'config'

const DEFAULT_TRANSCRIBE_URL = '/api/v1/audio/transcribe'

const parseBool = (value) =>
    value === true || value?.toString().toLowerCase() === 'true'

/** @deprecated Use CHATBOT_ENABLE_VOICE_DOCS / CHATBOT_ENABLE_VOICE_AGENT instead. */
const legacyEnableVoice = parseBool(config.CHATBOT_ENABLE_VOICE)

/** @deprecated Use CHATBOT_TRANSCRIBE_URL_DOCS / CHATBOT_TRANSCRIBE_URL_AGENT instead. */
const legacyTranscribeUrl =
    config.CHATBOT_TRANSCRIBE_URL || DEFAULT_TRANSCRIBE_URL

/**
 * Resolve per-mode voice flag with legacy CHATBOT_ENABLE_VOICE fallback.
 * New keys take precedence when explicitly set in config/manifest.
 */
const resolveVoiceFlag = (modeKey) => {
    const raw = config[modeKey]
    if (raw !== undefined && raw !== null && raw !== '') {
        return parseBool(raw)
    }
    return legacyEnableVoice
}

/**
 * Resolve per-mode transcribe URL with legacy CHATBOT_TRANSCRIBE_URL fallback.
 */
const resolveTranscribeUrl = (modeKey) => {
    const raw = config[modeKey]
    if (raw !== undefined && raw !== null && String(raw).trim() !== '') {
        return String(raw).trim()
    }
    return legacyTranscribeUrl
}

export const chatbotEnabled =
    config.CHATBOT_ENABLED === true ||
    config.CHATBOT_ENABLED?.toString().toLowerCase() === 'true'

export const chatbotEnableVoiceDocs = resolveVoiceFlag('CHATBOT_ENABLE_VOICE_DOCS')
export const chatbotEnableVoiceAgent = resolveVoiceFlag('CHATBOT_ENABLE_VOICE_AGENT')

export const chatbotTranscribeUrlDocs = resolveTranscribeUrl('CHATBOT_TRANSCRIBE_URL_DOCS')
export const chatbotTranscribeUrlAgent = resolveTranscribeUrl('CHATBOT_TRANSCRIBE_URL_AGENT')

/** @deprecated Use chatbotTranscribeUrlDocs / chatbotTranscribeUrlAgent instead. */
export const chatbotTranscribeUrl = legacyTranscribeUrl

/** @deprecated Use chatbotEnableVoiceDocs / chatbotEnableVoiceAgent instead. */
export const chatbotEnableVoice = legacyEnableVoice

/** Whether voice input is enabled for the given chat mode. */
export const isChatbotVoiceEnabledForMode = (mode) =>
    mode === 'docs' ? chatbotEnableVoiceDocs : chatbotEnableVoiceAgent

/** Transcribe endpoint for the given chat mode. */
export const getChatbotTranscribeUrlForMode = (mode) =>
    mode === 'docs' ? chatbotTranscribeUrlDocs : chatbotTranscribeUrlAgent

export const chatbotConfig = {
    serverUrl: config.CHATBOT_SERVER_URL,
    tenantId: config.CHATBOT_TENANT_ID || 'internal',
    assistantId: config.CHATBOT_ASSISTANT_ID,
    agentName: config.CHATBOT_AGENT_NAME || '',
    transcribeUrlDocs: chatbotTranscribeUrlDocs,
    transcribeUrlAgent: chatbotTranscribeUrlAgent,
    enableVoiceDocs: chatbotEnableVoiceDocs,
    enableVoiceAgent: chatbotEnableVoiceAgent,
}

/**
 * KeyboardEvent.key value that activates explain mode while held.
 * Defaults to 'e' — hold E to activate, release to deactivate.
 * The special value 'ctrlOrMeta' maps to Ctrl (Windows/Linux) or ⌘ Cmd (Mac).
 * Any KeyboardEvent.key string is accepted, e.g. 'Alt', 'Shift', 'F2'.
 * Note: printable keys (like 'e') are automatically ignored when an input,
 * textarea, or contenteditable element is focused.
 */
export const chatbotExplainShortcutKey =
    config.CHATBOT_EXPLAIN_SHORTCUT_KEY || 'e'

export default config
